import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { HookSection } from './components/HookSection';
import { AgitationSection } from './components/AgitationSection';
import { RevelationSection } from './components/RevelationSection';
import { Testimonials } from './components/Testimonials';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ClosingSection } from './components/ClosingSection';
import { FlameIcon } from './components/icons/Icons';
export function App() {
  return <div className="w-full bg-[#f7f4ec]" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main className="w-full" data-id="element-2">
        <Hero data-id="element-3" />
        <HookSection data-id="element-4" />
        <AgitationSection data-id="element-5" />
        <RevelationSection data-id="element-6" />
        <Testimonials data-id="element-7" />
        <OfferSection data-id="element-8" />
        <FaqSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <ClosingSection data-id="element-11" />
      </main>

      <footer className="w-full bg-[#161e18] py-10 text-center text-white/60" data-id="element-12">
        <div className="mx-auto max-w-3xl px-5" data-id="element-13">
          <div className="flex items-center justify-center gap-2 text-[#7fbf74]" data-id="element-14">
            <FlameIcon className="h-5 w-5" strokeWidth={2.2} data-id="element-15" />
            <span className="font-display text-base font-bold text-white" data-id="element-16">
              Método GastroSmart
            </span>
          </div>
          <p className="mx-auto mt-4 max-w-xl text-xs leading-relaxed" data-id="element-17">
            Este contenido tiene fines educativos y no sustituye el consejo
            médico profesional. Consulta a tu médico antes de iniciar cualquier
            protocolo. Resultados individuales pueden variar.
          </p>
          <p className="mt-4 text-xs" data-id="element-18">
            © 2026 GastroSmart. Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}